<template>
  <div>
    <layout>
      <div slot="content" class="con">
        <div class="left">
          <div
            class="conter"
            v-for="(item,index) in CategoryList"
            :key="item.category_id"
            @click="jumpTo(item.category_id,index)"
          >
            {{item.name}}
            <div class="normal" :class="{active:activeIndex==index}"></div>
          </div>
        </div>
        <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
        <div class="middle">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="cateImg" ref="title">
              <img
                :src="CategoryList[CategoryActiveImg].pad_image.file_path"
                v-if="CategoryList.length>0"
              />
            </div>
            <div class="middle_content" ref="content">
              <div
                class="item"
                v-for="(items,index) in goodsList"
                :key="index"
                @click="jump(items.goods_id)"
              >
                <div class="img">
                  <img :src="items.image[0].file_path | thumbnail(720,720)" alt />
                </div>
                <div class="message">
                  <div class="des" style="font-size:16px">{{items.goods_name}}</div>
                  <div
                    class="price"
                    style="font-size:14px;font-weight:700"
                  >￥{{items.goods_max_price}}</div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
        <!-- </van-pull-refresh> -->
      </div>
    </layout>
  </div>
</template>
<script>
import layout from "@/components/layout.vue";
import { getCategory, getList } from "../../api/http.js";
import { animateCSS } from "../../utils/animate.js";
import axios from "axios";
import { constants } from "crypto";
import { promises } from "fs";
import { Promise } from 'q';
export default {
  components: {
    layout
  },
  data() {
    return {
      CategoryList: [],
      CategoryActiveImg: 0,
      goodsList: [],
      ids: 0,
      activeIndex: 0,
      category_id: 0,
      itemsize: false,
      isLoading: false,
      loading: true,
      finished: true,
      currentPage: 1,
      pagecount: 1
    };
  },
  created() {
    if (localStorage.getItem("getCategory_size") != null) {
      this.itemsize = Boolean(
        localStorage.getItem("getCategory_size") === "true"
      );
    }
    this.init(this.ids);
  },
  methods: {
    init(ids) {
      getCategory().then(res => {
        this.CategoryList = res.data.list.all;
        //page,sortType,sortPrice,category_id,search,wxapp_id
        animateCSS(".cateImg", "fadeInDown");
        this.getList(1, "all", true, this.CategoryList[0].category_id, "", "");
      });
    },
    jumpTo(category_id, index) {
      this.category_id = category_id;
      this.CategoryActiveImg = index;
      this.activeIndex = index;
      // animateCSS(".cateImg", "fadeOutUp");
      // animateCSS(".middle_content", "fadeInDown");
      this.getList(1, "all", true, category_id, "", "", true);
    },
    jump(ids) {
      this.$router.push({
        path: "/details",
        query: {
          //路由传参时push和query搭配使用 ，作用是传递参数
          id: ids
        }
      });
    },
    onLoad() {
      this.currentPage = parseInt(this.currentPage) + 1;
      this.getList(
        this.currentPage,
        "all",
        true,
        this.category_id,
        this.searchresult || "",
        ""
      );
    },
    getList(
      page,
      sortType,
      sortPrice,
      category_id,
      search,
      tags,
      refresh = false
    ) {
      if (refresh) {
        this.finished = false;
        this.goodsList = [];
        animateCSS(".cateImg", "fadeInDown");
      }
      getList(page, sortType, sortPrice, category_id, search, tags).then(
        res => {
          this.goodsList = this.goodsList.concat(res.data.list.data);
          this.currentPage = res.data.list.current_page;
          this.pagecount = res.data.list.last_page;
          if(page==1){
            animateCSS(".middle_content", "fadeInUp");
          }
          if (this.currentPage >= this.pagecount) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          this.loading = false;
        }
      );
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.con {
  position: relative;
  display: flex;
  padding-left: 139px;
  height: 100%;
  background: #ececec;
  -webkit-overflow-scrolling: touch;
  // overflow-scrolling: touch;
  .left {
    position: fixed;
    left: 0;
    top: 44px;
    bottom: 0;
    width: 139px;
    line-height: 49px;
    text-align: center;
    background: #fff;
    .conter {
      font-size: 16px;
      color: #1a1a1a;
      .normal {
        margin: 0px auto;
        width: 30px;
        height: 4px;
        background: #fff;
      }
      .active {
        margin: 0px auto;
        width: 30px;
        height: 4px;
        background: #3e210e;
      }
    }
  }
  .middle {
    padding: 8px 9px;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow: auto;
    .cateImg {
      width: 100%;
      height: 210px;
      overflow: hidden;
      margin-bottom: 10px;
      border-radius: 4px;
      img {
        width: 100%;
        position: relative;
        transform: translateY(-50%);
        top: 50%;
      }
    }
    .AnimateDelay {
      animation-delay: 500ms;
    }
    .middle_content {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      flex: 1;
      .item {
        width: 50%;
        box-sizing: border-box;
        margin-bottom: 10px;
        overflow: hidden;
        .img {
          width: 429px;
          height: 429px;
          background: #f9f9f9;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            position: relative;
          }
        }
        .message {
          padding: 9px 10px;
          color: #3e210e;
          background: rgba(255, 255, 255, 1);
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          overflow: hidden;
          .des {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .item:nth-child(odd) {
        padding-right: 5px;
      }
      .item:nth-child(even) {
        padding-left: 5px;
      }
    }
  }
  .right {
    position: fixed;
    right: 0;
    top: 44px;
    bottom: 0;
    width: 47px;
    line-height: 49px;
    text-align: center;
    background: #fff;
    .conter {
      font-size: 16px;
    }
    .active {
      background: #3e210e;
    }
  }
}
</style>



